interface ProgressProps {
  value: number
  size?: 'sm' | 'md' | 'lg'
  showLabel?: boolean
}

const sizeToHeight: Record<NonNullable<ProgressProps['size']>, string> = {
  sm: 'h-2',
  md: 'h-3',
  lg: 'h-4',
}

const Progress = ({ value, size = 'md', showLabel = false }: ProgressProps) => {
  const clamped = Math.max(0, Math.min(100, Math.round(value)))
  return (
    <div className="flex items-center w-full">
      <div className={`w-full bg-gray-200 dark:bg-gray-700 rounded-full ${sizeToHeight[size]} overflow-hidden`}>
        <div
          className="bg-primary-600 h-full rounded-full transition-all duration-300"
          style={{ width: `${clamped}%` }}
        />
      </div>
      {showLabel && (
        <span className="ml-2 text-sm text-gray-600 dark:text-gray-400 min-w-[3rem]">{clamped}%</span>
      )}
    </div>
  )
}

export default Progress


